import React, { useState } from "react";
import { Stack } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import MapMarkerRainforestInfoSection from "./MapMarkerRainforestInfoSection";
import MapMarkerRainforestInfoProductDialog from "./MapMarkerRainforestInfoProductDialog";
import MapMarkerRainforestProductChip from "./MapMarkerRainforestProductChip";
import { useMapForecoFetchProducts } from "hooks/maps/useMapForecoFetchProducts";
import { getProductIconSrc } from "libraries/map";

type Props = {
  products: string[];
};

const MapMarkerRainforestInfoProducts = ({ products }: Props) => {
  const [selectedProduct, setSelectedProduct] = useState<string | null>(null);
  const { getProductByTag, getProductLabel } = useMapForecoFetchProducts();

  if (!products || products.length === 0) {
    return null;
  }

  const productInfo = getProductByTag(selectedProduct);

  return (
    <>
      <MapMarkerRainforestInfoSection
        title="Value Chains & Products"
        icon={<DoneAllIcon fontSize="small" />}
      >
        <Stack
          direction="row"
          spacing={1.25}
          flexWrap="wrap"
          useFlexGap
          sx={{ mt: 1.5 }}
        >
          {products.map((p) => {
            const hasInfo = !!getProductByTag(p);
            const iconUrl = getProductIconSrc(p);

            return (
              <MapMarkerRainforestProductChip
                key={p}
                productTag={p}
                label={getProductLabel(p)}
                iconUrl={iconUrl ?? undefined}
                hasInfo={hasInfo}
                onSelect={setSelectedProduct}
              />
            );
          })}
        </Stack>
      </MapMarkerRainforestInfoSection>

      <MapMarkerRainforestInfoProductDialog
        productTag={selectedProduct}
        productInfo={productInfo}
        onClose={() => setSelectedProduct(null)}
      />
    </>
  );
};

export default MapMarkerRainforestInfoProducts;



